import { GET_PATIENT_ADDRESS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    address: Add[];
}

export interface Add {
    _id: string;
    pid: string;
    docid: string;
    uuid: string;
    address: AddressObj;
    created_at: string;
}

export interface AddressObj {
    line1: string;
    line2: string;
    city: string;
    state: string;
    city_id: string;
    place_id: string;
    coordinates: string;
    pincode: string;
}

export default (docid: string, patient_oid: string): Promise<Response> => {
    return fetchWithRefresh(GET_PATIENT_ADDRESS(docid, patient_oid)).then((res) => res.json());
};
